import React from 'react'
import { Icon, ShowIf } from '@ztechapps/webui.util'
import { CellWithContextMenu } from '@ztechapps/webui.menu'
import { RowContextMenu } from './RowContextMenu'
import { RowExtension } from '../RowExtension'
import { ExtendingRow } from '../../Table/extending-row'

export const Row = (props) => {
  const { name, description, isDefault } = props
  const extensionRow = <RowExtension {...{ ...props }} />

  return (
    <ExtendingRow {...{ ...props, colSpan: 2, extensionRow }}>
      <CellWithContextMenu contextMenuContent={<RowContextMenu template={props} />}>
        <div>
          <ShowIf condition={isDefault}>
            <span className="text-warning">
              <Icon title="Default template" name="star" />{' '}
            </span>
          </ShowIf>
          <b>{name}</b> - <small>{description}</small>
        </div>
      </CellWithContextMenu>
    </ExtendingRow>
  )
}
